import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import PreviewFrame from '../PreviewFrame';
import EditableBlock from '../EditableBlock';
import EditableText from '../EditableText';
import SplashCard from '../SplashCard';

import { TEXT_EDITOR_FIELDS, BUTTON_EDITOR_FIELDS } from '../../const';

const TermsPreview = ({ devicePreview, editable, selectedLanguage, languageOptions, setLanguageOptions, terms, onUpdateTermsBlock, imageInfo, onUpdateImageBlock }) => {
  const theme = useTheme();

  const isMobile = devicePreview === 'mobile';

  return (
    <PreviewFrame
      devicePreview={devicePreview}
      languageOptions={languageOptions}
      setLanguageOptions={setLanguageOptions}
      selectedLanguage={selectedLanguage}
      editable={editable}
      imageInfo={imageInfo}
      onUpdateImageBlock={onUpdateImageBlock}
    >
      <SplashCard isMobile={isMobile} maxWidth={650}>
        {/* Title */}
        {!!terms['title.terms']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Title"
            editorFields={TEXT_EDITOR_FIELDS}
            style={terms['title.terms'].style}
            onStyleChange={style => onUpdateTermsBlock('title.terms', { style })}
            blockSx={{ alignSelf: 'center', width: '100%' }}
          >
            <EditableText
              value={terms['title.terms']?.text}
              editable={editable}
              onChange={html =>
                onUpdateTermsBlock('title.terms', {
                  text: html,
                })
              }
              component="div"
              sx={{
                textAlign: 'center',
                fontSize: `${terms['title.terms'].style.fontSize}px`,
                fontFamily: terms['title.terms'].style.fontFamily,
                color: terms['title.terms'].style.fontColor,
                fontWeight: theme.typography.customFontWeight[1],
                padding: '6px 0px',
                lineHeight: 1.5,
                outlineStyle: 'none',
              }}
            />
          </EditableBlock>
        )}

        {/* Content */}
        {!!terms['content.terms']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Terms and Conditions"
            editorFields={TEXT_EDITOR_FIELDS}
            style={terms['content.terms'].style}
            onStyleChange={style => onUpdateTermsBlock('content.terms', { style })}
            blockSx={{ width: '100%' }}
          >
            <Box sx={{ padding: editable ? '16px' : '0' }}>
              <EditableText
                value={terms['content.terms']?.text}
                editable={editable}
                onChange={html =>
                  onUpdateTermsBlock('content.terms', {
                    text: html,
                  })
                }
                component="div"
                sx={{
                  fontSize: `${terms['content.terms'].style.fontSize}px`,
                  fontFamily: terms['content.terms'].style.fontFamily,
                  color: terms['content.terms'].style.fontColor,
                  textAlign: 'left',
                  outlineStyle: 'none',
                }}
              />
            </Box>
          </EditableBlock>
        )}

        {/* Button */}
        {!!terms['button.back']?.show && (
          <EditableBlock
            editable={editable}
            editorTitle="Action Button"
            editorFields={BUTTON_EDITOR_FIELDS}
            style={terms['button.back'].style}
            onStyleChange={style => onUpdateTermsBlock('button.back', { style })}
            blockSx={{
              width: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: 36,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '20px',
                backgroundColor: terms['button.back'].style.buttonColor,
              }}
            >
              <EditableText
                value={terms['button.back']?.text}
                editable={editable}
                onChange={html =>
                  onUpdateTermsBlock('button.back', {
                    text: html,
                  })
                }
                component="div"
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
                sx={{
                  fontSize: theme.typography.customFontSize[2],
                  fontFamily: terms['button.back'].style.fontFamily,
                  color: terms['button.back'].style.fontColor,
                  fontWeight: theme.typography.customFontWeight[1],
                  width: '100%',
                  textAlign: 'center',
                  outlineStyle: 'none',
                  cursor: editable ? 'text' : 'pointer',
                }}
              />
            </Box>
          </EditableBlock>
        )}
      </SplashCard>
    </PreviewFrame>
  );
};

export default TermsPreview;
